import React from 'react';
import Row from '../Symbols/Row';
import InputCurrency from '../Symbols/InputCurrency';
import Button from '../Symbols/Button';
import Result from './Result';
import Form from '../Symbols/Form';
import Input from '../Symbols/Input';
import Wrapper from '../Symbols/Wrapper';
import InputSelect from '../Symbols/InputSelect';
import { YEARS_SICK } from '../LegalParameters/Constants';
import Info from '../Symbols/Info';

const years = YEARS_SICK.map(year => ({ name: year, value: year }));

const emptyFunc = () => {};

export default props => {
	const {
		validateHandler = emptyFunc,
		changeHandler = emptyFunc,
		payChangeHandler = emptyFunc,
		errors = {},
		state: { pay, pay_hour, hours, days, year },
		result = null,
		onSubmit,
		reset,
	} = props;

	return (
		<Wrapper>
			<Form onSubmit={onSubmit} title="Kalkulačka - Nemocenská">
				<InputSelect
					label="Výpočet pro rok:"
					name="years"
					value={year}
					onChange={changeHandler('year')}
					onBlur={validateHandler('year')}
					passedProps={{ 'data-cy': 'year' }}
					select={years}
					error={errors.year}
				/>

				<InputCurrency
					label="Hrubá měsíční mzda"
					onChange={payChangeHandler}
					onBlur={validateHandler('pay')}
					value={pay}
					name="pay"
					error={errors.pay}
					passedProps={{ 'data-cy': 'pay' }}
				/>

				<InputCurrency
					label="Průměrný hodinový výdělek v posledním čtvrtletí"
					onChange={changeHandler('pay_hour')}
					onBlur={validateHandler('pay_hour')}
					value={pay_hour}
					name="pay_hour"
					error={errors.pay_hour}
					passedProps={{ 'data-cy': 'pay_hour', step: '0.01' }}
				/>

				<Input
					label={
						<>
							Počet hodin pracovní neschopnosti v prvních 14 dnech <sup>1</sup>
						</>
					}
					name="hours"
					value={hours}
					type="number"
					onChange={changeHandler('hours')}
					onBlur={validateHandler('hours')}
					passedProps={{ min: 0, 'data-cy': 'hours' }}
					error={errors.hours}
				/>

				<Input
					label="Celkový počet dní pracovní neschopnosti"
					name="days"
					value={days}
					type="number"
					onChange={changeHandler('days')}
					onBlur={validateHandler('days')}
					passedProps={{ min: 0, 'data-cy': 'days' }}
					error={errors.days}
				/>

				<div css={Row}>
					<Button data-cy="submit">Výpočet</Button>
				</div>

				{result && <Result sick={result} />}
				{result && (
					<div css={Row}>
						<Button onClick={reset} data-cy="reset">
							Nový výpočet
						</Button>
					</div>
				)}

				<Info css={Row}>
					<p>
						<sup>1</sup> Započítávají se pracovní dny a placené svátky.
					</p>
					<p>
						Náhrada mzdy se poskytuje v době prvních 14 kalendářních dní pracovní neschopnosti za
						pracovní dny a za placené svátky. Nemocenské dávky jsou vypláceny od 15. dne pracovní
						neschopnosti za každý kalendářní den.
					</p>
				</Info>
			</Form>
		</Wrapper>
	);
};
